import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import StoreContext from './../../../Store/Context';
import { Row, Col,Button } from "reactstrap";
import { Announcement, ProfilePanelTeacher,validateTokenStorage } from "../../Constants/Util";
import { ChangeEmail, ChangeAvatar, ChangeCelphone,ChangePassword } from "./../../Constants/Modal";
import { getProfile,getAnnouncement, putEmail,  putStudentPassword, putCellphone,urlHttpPostAvatar } from "./../../Constants/Services";
import {ITeacherProfile,IAnnouncement}   from  "./../../Constants/Interfaces"

interface IHomeState {
  isOpenModalEmail: boolean;
  isOpenModalAvatar: boolean;
  isOpenModalCelphone: boolean;
  isOpenModalPassword:boolean;
  dataProfileTeacher: ITeacherProfile;
  dataAnnouncement: IAnnouncement[];
  formPassword: {
    per_password: string;
    per_password_again: string;
  };
  loading: boolean;
  formTeacher: {
    per_celphone1: string;
    per_email: string;
  };
  teach_img: string;
  msg_error: string;
}

class HomeTeacher extends Component<RouteComponentProps<{}>, IHomeState> {
  static contextType = StoreContext
  constructor(props: any) {
    super(props);
    this.state = {
      isOpenModalCelphone: false,
      isOpenModalEmail: false,
      isOpenModalAvatar: false,
      isOpenModalPassword:false,
      loading: false,
      formTeacher: {
        per_email: "",
        per_celphone1: "",
      },
      dataProfileTeacher: {
        per_id: "",
        per_name: "",
        per_lastname: "",
        per_cedula: "",
        per_email: "",
        per_celphone1: "",
        per_password:"",
        gr_desc: "",
        gr_alias: "",
        grc_trimestre: "",
      },
      formPassword: {
        per_password: "",
        per_password_again: "",
      },
      teach_img: "",
      dataAnnouncement: [],
      msg_error: "",
    };

    this.handleModalEmail = this.handleModalEmail.bind(this);
    this.handleModalAvatar = this.handleModalAvatar.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangeCelphone = this.onChangeCelphone.bind(this);
    this.handlerPutEmail = this.handlerPutEmail.bind(this);
    this.handlerPutCellphone = this.handlerPutCellphone.bind(this);
    this.handleModalCellphone = this.handleModalCellphone.bind(this); 
    this.handlerPutPassword = this.handlerPutPassword.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.handleModalPassword = this.handleModalPassword.bind(this);
  }
  handleModalPassword() {
    this.setState((prevState) => ({
      isOpenModalPassword: !prevState.isOpenModalPassword,
      formPassword: {
        per_password: "",
        per_password_again: "",
      },
    }));
  }
  async fetchProfile() {
    const response = await getProfile(this.context.per_id, this.context.usr_type.replace(/\//g, ""));
    this.setState({
      dataProfileTeacher: response.teacher[0],
      teach_img: response.teach_img,
      loading: false,
    });
  }

  async fetchAnnouncement() {
    const response = await getAnnouncement();
    this.setState({ dataAnnouncement: response, loading: false });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchProfile();
    this.fetchAnnouncement();

  }

  handleModalCellphone() {
    this.setState((prevState) => ({
      isOpenModalCelphone: !prevState.isOpenModalCelphone,
      formTeacher: {
        per_email: "",
        per_celphone1: "",
      },
      msg_error:""
    }));
  }

  handleModalEmail() {
    this.setState((prevState) => ({
      isOpenModalEmail: !prevState.isOpenModalEmail,
      formTeacher: {
        per_email: "",
        per_celphone1: "",
      },
      msg_error:""
    }));
  }

  handleModalAvatar() {
    this.setState((prevState) => ({
      isOpenModalAvatar: !prevState.isOpenModalAvatar,
    }));
    setTimeout(() => {
      this.fetchProfile();
    }, 1000);
  }

  handlerPutEmail() {
    const props = this.state;
    if (props.formTeacher.per_email.length > 12) {
      const body = {
        per_id: props.dataProfileTeacher.per_id,
        per_email: props.formTeacher.per_email,
      };
      putEmail(body);
      this.setState({
        isOpenModalCelphone: false,
        isOpenModalAvatar: false,
        isOpenModalEmail: false,
        loading: true,
      });
      setTimeout(() => {
        this.fetchProfile();
      }, 1000);
    } else {
      this.setState({
        msg_error: "Escribe un correo valido",
      });
    }
  }

  handlerPutCellphone() {
    const props = this.state;
    if (props.formTeacher.per_celphone1.length > 5) {
      const body = {
        per_id: props.dataProfileTeacher.per_id,
        per_celphone1: props.formTeacher.per_celphone1,
      };
      putCellphone(body);
      this.setState({
        isOpenModalCelphone: false,
        isOpenModalAvatar: false,
        isOpenModalEmail: false,
        loading: true,
      });
      setTimeout(() => {
        this.fetchProfile();
      }, 1000);
    } else {
      this.setState({
        msg_error: "Escribe un # de celular valido",
      });
    }
  }

  onChangeCelphone(e: any) {
    this.setState({
      formTeacher: {
        ...this.state.formTeacher,
        [e.target.name]: e.target.value,
      },
    });
  }

  emailClick() {
    this.setState((prevState) => ({
      isOpenModalCelphone: !prevState.isOpenModalCelphone,
    }));
  }

  onChangeEmail(e: any) {
    this.setState({
      formTeacher: {
        ...this.state.formTeacher,
        [e.target.name]: e.target.value,
      },
    });
  }
  handlerPutPassword() {
    const props = this.state;
    const body = {
      per_id: this.context.per_id,
      per_password: props.formPassword.per_password,
    };
    if(props.formPassword.per_password === props.formPassword.per_password_again){
      putStudentPassword(body);
      this.setState({
        isOpenModalPassword: false,
        isOpenModalAvatar: false,
        isOpenModalEmail: false,
        loading: false,
      });
      setTimeout(() => {
        this.fetchProfile();
      }, 1000);
    }

  }

  onChangePassword(e: any) {
    this.setState({
      formPassword: {
        ...this.state.formPassword,
        [e.target.name]: e.target.value,
      },
    });
  }
  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalCelphone && (
          <ChangeCelphone
            celphone={props.dataProfileTeacher.per_celphone1}
            isOpen={props.isOpenModalCelphone}
            toggle={this.handleModalCellphone}
            toggleSave={this.handlerPutCellphone}
            onChange={this.onChangeCelphone}
            msg_error={props.msg_error}
          />
        )}
        {props.isOpenModalEmail && (
          <ChangeEmail
            email={props.dataProfileTeacher.per_email}
            isOpen={props.isOpenModalEmail}
            toggle={this.handleModalEmail}
            toggleSave={this.handlerPutEmail}
            onChange={this.onChangeEmail}
            msg_error={props.msg_error}
          />
        )}
        {props.isOpenModalAvatar && (
          <ChangeAvatar
            isOpen={props.isOpenModalAvatar}
            toggle={this.handleModalAvatar}
            IMG_AVATAR={props.teach_img}
            nameImg={props.dataProfileTeacher.per_id}
            urlHttp={urlHttpPostAvatar}
          />
        )}
               {props.isOpenModalPassword && (
          <ChangePassword
            password={props.dataProfileTeacher.per_password}
            isOpen={props.isOpenModalPassword}
            toggle={this.handleModalPassword}
            toggleSave={this.handlerPutPassword}
            onChange={this.onChangePassword}
          />
        )}
        <Row className="">
          <Col xs={12} className="text-center">
            <h5 className="font-weight-bold">Perfil del docente</h5>
          </Col>
          <Col sm={12} className="text-right mt-4">
            <Button className="info" onClick={() => this.handleModalPassword()}>
              Cambiar contraseña
            </Button>
          </Col>
          <Col xs={12} className="mt-4">
            <ProfilePanelTeacher
              props={props.dataProfileTeacher}
              handleModalEmail={this.handleModalEmail}
              handleModalCellphone={this.handleModalCellphone}
              handleModalAvatar={this.handleModalAvatar}
              AVATAR={props.teach_img}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="text-center mt-4">
            <h5 className="font-weight-bold">Muro de anuncios</h5>
          </Col>

          <Col xs={12} className="text-center">
          <div className = "div-announcement">
              {props.dataAnnouncement.map((item: any, i: any) => (
                <Announcement key={i} data={item} />
              ))}
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default HomeTeacher;
